export const Translations_NL = {
	footer: {
		join: "Doe nu mee aan deze discussie. Geen app of login vereist.",
		climate: "Een klimaatpositieve discussie.",
		tree: "Deze boom is geplant.",
		start: "Start gratis videodiscussies.",
	},
};
